import { getRoot, IStateTreeNode } from 'mobx-state-tree';
import { IRootStore } from '@stores/RootStore';
import { IBrandsStore } from './types';

export const withBrandsStore = (self: IStateTreeNode) => {
  return {
    views: {
      get brandsStore(): IBrandsStore {
        return getRoot<IRootStore>(self).brandsStore;
      },
    },
  };
};
